import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { otherConfigOptionsAttributes } from "../../mandatoryConfigs/configSetupScreen/widget/configBottomBar";
// import { FeatureSelectionOptionsContext } from "../../../../components/newPortal/NewPortalLayout";
import { FeatureSelectionOptionsContext } from "../../../settings/components/FeatureSelectionOptionsContext";
import "../feautreSelectionScreen.css";
import { Box, Button } from "@mui/material";
import feautreSelectionBg from "../../../../assets/image/png/feautre-selection-bg.png";

import PhoneFrameComponent from "../../../onboarding/PhoneFrame";
import NonActivatedCard from "./optionalFeautreNonActivatedCard";
import { OptionType } from "../../../manageHomepage/ManageHomePageTypes";
import { ImageIdToSVGMap } from "../../../../components/newPortal/UiConfigOptions";
import { useLocation } from "react-router-dom";
import { appSubscriptionCheck } from "../../../../services/uiConfigService";

export default function AnimatedContainer(props: {
  allConfigOptions: otherConfigOptionsAttributes[];
  setAllConfigOptions: React.Dispatch<
    React.SetStateAction<otherConfigOptionsAttributes[]>>;
  standard: string | undefined;
  currentRole: OptionType;
  setFeatureChangeList: React.Dispatch<React.SetStateAction<string[]>>
}) {
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [flyingOption, setFlyingOption] =
    useState<otherConfigOptionsAttributes | null>(null); // To track the flying option
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const [removingOption, setRemovingOption] = useState<string | null>(null);
  const [isOptionalActivated, setIsOptionalActivated] =
    useState<boolean>(false);

  const [selectedConfigImage, setSelectedConfigImage] =
    useState<string>(feautreSelectionBg);
  const [optionalConfigImage, setOptionalConfigImage] =
    useState<string>(feautreSelectionBg);
  
  const {
    uiConfigOptionsProp = [],
    setUiConfigOptionsProp = () => {},
  } = useContext(FeatureSelectionOptionsContext);
  const location=useLocation();
  const isOnboarding = location.pathname.includes("onboarding");


  const selectedOptionsLength = uiConfigOptionsProp?.filter(
    (option) =>
      option.isSelected &&
      !option.isMandatory
      //  && option.role.includes(props.currentRole?.id)
  ).length;

  useEffect(() => {
    props.setAllConfigOptions([...uiConfigOptionsProp]);
  }, [uiConfigOptionsProp]);

  const handleAddOptions = () => {
    props.setFeatureChangeList((prev) => {
      for (let option of selectedOptions) {
        const index = prev.indexOf(option);
        if (index !== -1) {
          prev.splice(index, 1);
        } else {
          prev.push(option);
        }
      }

      return [...prev];
    });
    setUiConfigOptionsProp((prevState :otherConfigOptionsAttributes[] ) =>
      prevState.map((opt : otherConfigOptionsAttributes) =>
        selectedOptions.includes(opt.id)
          ? { ...opt, isSelected: true, action: "added" }
          : opt
      )
    );
    setSelectedOptions([]); // Clear the selected options
  };

  const handleCheckboxChange = (optionId: string) => {
    setSelectedOptions(
      (prev) =>
        prev?.includes(optionId)
          ? prev?.filter((id) => id !== optionId) // Remove if already selected
          : [...prev, optionId] // Add if not selected
    );
  };

  const handleRemoveOption = (option: otherConfigOptionsAttributes) => {
    props.setFeatureChangeList((prev) => {
      const index = prev.indexOf(option.id);
      if (index !== -1) {
        prev.splice(index, 1);
      } else {
        prev.push(option.id);
      }

      return [...prev];
    });

    setRemovingOption(option.id); // Trigger the animation

    setTimeout(() => {
      setSelectedOption(null);
      setUiConfigOptionsProp((prevState : otherConfigOptionsAttributes[]) =>
        prevState.map((opt : otherConfigOptionsAttributes) =>
          opt.id === option.id
            ? { ...opt, isSelected: false, action: "removed" }
            : opt
        )
      );
      setRemovingOption(null); // Reset the removing option after animation
    }, 400); // Ensure this matches the animation duration
  };

  return (
    <div
      style={{
        display: "flex",
        position: "relative",
        justifyContent: "space-between",
      }}
    >
      {/* Left side: Selected options */}
      <div className="selected-configuration-container" style={{height : !isOnboarding ? "73vh" : "78vh"}}>
        <div
          style={{
            flex: "7 1 0",
            borderRadius: "5px",
            padding: "15px",
            display: "flex",
            flexDirection: "row",
            height: !isOnboarding ? "97%" : "100%",
            gap:"2%"
          }}
        >
          <Box sx={{ width: "65%", height: "100%" }}>
            {" "}
            {/* Heading */}
            <div
              className="heading"
              style={{
                display: "flex",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "13px",
                  marginRight: "8px",
                  borderLeft: "#00c6b1 3px solid",
                  paddingLeft: "5px",
                }}
              >
                Your App Is Ready With Following Features
              </div>
            </div>
            {/* Content Container */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                overflow: "scroll",
                height: "95%",
              }}
            >
              <>
                <div
                  style={{
                    flex: "2",
                    gridTemplateColumns: "repeat(3,1fr)",
                    rowGap: "15px",
                    gap: "10px",
                    padding: "4%",
                    listStyleType: "none",
                  }}
                >
                  {" "}
                  {uiConfigOptionsProp?.filter(
                      (option) =>
                        option.isSelected &&
                        !option.isMandatory &&
                        appSubscriptionCheck(option,props.standard)
                    )?.map((option) => (
                      <div
                        key={option.id}
                        className={
                          removingOption === option.id ? "exitAnimation" : ""
                        }
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between", // Space between items
                          borderBottom: "1px solid #EFEFEF",
                          alignItems: "center",
                          padding: "10px", // Padding around each item
                          marginBottom: "25px", // Space between each item
                        }}
                      >
                        <div
                          className="hover-button-container"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <div style={{ position: "relative" }}>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                minWidth: 60,
                                minHeight: 60,
                                boxSizing: "content-box",
                                marginRight: "6px",
                                borderRadius: 2,
                                backgroundColor: "#FFFFFF",
                                color: "#000",
                                boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
                                "&:hover": {
                                  backgroundColor: "#FFFFFF",
                                  border: !option.isSelected
                                    ? "1px solid #227C9D "
                                    : "0px solid #227C9D ",
                                },
                              }}
                            >
                              <img
                                onClick={() =>
                                  setSelectedConfigImage(option.hintImage)
                                }
                                src={ImageIdToSVGMap[option.icon ?? "default"]}
                                alt={`${option.id} icon`}
                                style={{
                                  height: "30px", // Fixed height for icons
                                  width: "30px", // Fixed width for icons
                                  borderRadius: "5px", // Rounded corners for the image
                                }}
                              />
                            </Box>
                          </div>
                          <div style={{ flex: "1", marginLeft: "10px" }}>
                            <div
                              style={{
                                fontWeight: 700,
                                fontSize: "13px",
                                color: "#333",
                                marginBottom: "5px",
                              }}
                            >
                              {option.id}
                            </div>
                            <div style={{ fontSize: "12px", color: "#666" }}>
                              {option.description}
                            </div>
                          </div>
                        </div>

                        <input
                          type="checkbox"
                          disabled={option.isSelected && option.isMandatory}
                          checked={option.isSelected}
                          onChange={() => handleRemoveOption(option)}
                          className="custom-checkbox"
                        />
                      </div>
                    ))}
                  {uiConfigOptionsProp
                    ?.filter(
                      (option) =>
                        option.isSelected &&
                        option.isMandatory &&
                        appSubscriptionCheck(option,props.standard)
                    )
                    ?.map((option) => (
                      <div
                        key={option.id}
                        className={
                          removingOption === option.id ? "exitAnimation" : ""
                        }
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between", // Space between items
                          borderBottom: "1px solid #EFEFEF",
                          alignItems: "center",
                          padding: "10px", // Padding around each item
                          marginBottom: "25px", // Space between each item
                        }}
                      >
                        <div
                          className="hover-button-container"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <div style={{ position: "relative" }}>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                minWidth: 60,
                                minHeight: 60,
                                boxSizing: "content-box",
                                marginRight: "6px",
                                borderRadius: 2,
                                backgroundColor: "#FFFFFF",
                                color: "#000",
                                boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
                                "&:hover": {
                                  backgroundColor: "#FFFFFF",
                                  border: !option.isSelected
                                    ? "1px solid #227C9D "
                                    : "0px solid #227C9D ",
                                },
                              }}
                            >
                              <img
                                onClick={() =>
                                  setSelectedConfigImage(option.hintImage)
                                }
                                src={ImageIdToSVGMap[option.icon ?? "default"]}
                                alt={`${option.id} icon`}
                                style={{
                                  height: "30px", // Fixed height for icons
                                  width: "30px", // Fixed width for icons
                                  borderRadius: "5px", // Rounded corners for the image
                                }}
                              />
                            </Box>
                          </div>
                          <div style={{ flex: "1", marginLeft: "10px" }}>
                            <div
                              style={{
                                fontWeight: 700,
                                fontSize: "13px",
                                color: "#333",
                                marginBottom: "5px",
                              }}
                            >
                              {option.id}
                            </div>
                            <div style={{ fontSize: "12px", color: "#666" }}>
                              {option.description}
                            </div>
                          </div>
                        </div>

                        <input
                          type="checkbox"
                          disabled={option.isSelected && option.isMandatory}
                          checked={option.isSelected}
                          onChange={() => handleRemoveOption(option)}
                          className="custom-checkbox"
                        />
                      </div>
                    ))}
                </div>
              </>
            </div>
          </Box>
          <Box
            sx={{
              width: "35%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {" "}
            {/* Image Section */}
            <PhoneFrameComponent
              allowTriggerChanges
              widthValue={"100%"}
              heightValue={"100%"}
            />
          </Box>
        </div>
      </div>

      {/* Right side: Non Mandatory options */}
      <div
        className={`optional-configuration-container ${
          isOptionalActivated ? `activated` : ""
        }`} style={{height : !isOnboarding ? "67vh" : "71vh"}}
      >
        {!isOptionalActivated ? (
          <>
            <NonActivatedCard setIsOptionalActivated={setIsOptionalActivated} />
          </>
        ) : (
          <>
            <div className="header-info">
              <h3
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: "#20c997",
                }}
              >
                Advanced Features
              </h3>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginTop: "65px",
                height: "75%",
                overflowX: "scroll",
                overflowY: "visible",
                whiteSpace: "nowrap",
                alignItems: "center",
              }}
            >
              {props.allConfigOptions?.filter(
                  (option) =>
                    !option.isMandatory &&
                    !option.isSelected &&
                    appSubscriptionCheck(option,props.standard)
                )?.map((option) => (
                  <div
                    key={option.id}
                    style={{
                      display: "flex",
                      width: "93%",
                      margin: "5px",
                      alignItems: "center",
                      padding: "10px",
                      borderRadius: "2px",
                      backgroundColor: "#f9f9f9",
                      boxShadow: "0 1px 4px rgba(0, 0, 0, 0.1)",
                      position: "relative", // Make the parent a positioned container
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={selectedOptions.includes(option.id)}
                      onChange={() => handleCheckboxChange(option.id)}
                      className="custom-checkbox"
                      style={{
                        position: "absolute",
                        border: "0.5px solid grey",
                        left: "-21px", // Adjust to position on the left border
                        top: "35%", // Align vertically
                        transform: "translateY(-50%)", // Center vertically
                      }}
                    />
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        padding: 1,
                        borderRadius: 2,
                        border: "1px solid #70a9bf",
                        backgroundColor: "#FFFFFF",
                        boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.1)",
                        marginLeft: "10px",
                      }}
                    >
                      <img
                        src={ImageIdToSVGMap[option.icon ?? "default"]}
                        alt={`${option.id} icon`}
                        style={{
                          height: "40px",
                          width: "40px",
                          borderRadius: "5px",
                        }}
                      />
                    </Box>
                    <div
                      style={{
                        marginLeft: "10px",
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: "#333",
                      }}
                    >
                      {option.id}
                    </div>
                  </div>
                ))}
            </div>
            <div className="optional-add-btn-container">
              <Button
                variant="contained"
                onClick={handleAddOptions}
                sx={{
                  alignSelf: "center",
                  marginY: "1rem",
                  fontSize: "16px",
                  backgroundColor: "#20c997",
                  width: "100px",
                  zIndex: "1000",
                }}
              >
                ADD
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
